var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"federation-link"},[(_vm.federation)?_c('div',{staticClass:"name",attrs:{"title":"More details"},on:{"click":_vm.toggleDetails}},[_vm._v(_vm._s(_vm.federation.alias || _vm.federation.name))]):_c('div',{staticClass:"empty"},[_vm._v("-")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f5be116","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/links/Federation.vue
// module id = null
// module chunks = 